import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { GuidedProcessSupportBlock } from '../../global/components/guided-process-support-block';
import { GpsType } from '../../global/components/layout/layout-models';
import { MainContent } from '../../global/components/layout/main-content-container';
import { PageContainer } from '../../global/components/layout/page-container';
import { PageHeader } from '../../global/components/layout/page-header';
import { SideBarContent } from '../../global/components/layout/sidebar-content';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';
import { patchNotification, patchAllNotificationStatus } from '../../global/ducks/notification-prc-api';
import { MapNotification } from '../../global/helpers/form-data-helper';
import { useGpsType } from '../../global/hooks/useGpsType';
import { TcsmSiteSettingsProps } from '../../global/models/epi-model';
import { TcsmStates } from '../../root/tcsm-model';
import { ListPagination } from '../../search/components/list-pagination';
import { SearchApp } from '../../search/components/search-app';
import { SearchList } from '../../search/components/search-list';
import { SearchProps } from '../arc/models/arc-epi-props';
import { NotificationItem } from './notification-item';
import { Notification, NotificationStatus } from './notification-models';
import { setAllNotificationRead, setNotificationRead } from './notification-slice';


export function NotificationAlertPage() {

	const initialList = useSelector<TcsmStates, Notification[]>(state => state?.notificationState?.notifications);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);	
	const siteSettingsLoaded = useSelector<TcsmStates, boolean>(state => state?.epiProps?.siteSettingsState?.siteSettingsLoaded);	
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
	const gpsItem = useGpsType(GpsType.ALERT_NOTIFICATION);
	const dispatch = useDispatch();
	const dismissHandler = (notification: Notification) => {
		const payload = {
			notification_status: NotificationStatus.DISMISSED,
			notification_type: notification?.notification_type,
			recipient_guid: notification?.recipient_guid,
		};
		dispatch(patchNotification(notification?.notification_id, payload, () => dispatch(setNotificationRead(notification?.notification_id))));
	};

	useEffect(() => {
		dispatch(patchAllNotificationStatus(guid, NotificationStatus.DISMISSED,
			() => {
				dispatch(setAllNotificationRead(true));
			}));
	}, []);

	function RenderNoNotificationsMessage(){
		if (initialList?.length > 0) return null;

		return (<WysiwygWithReactLink content={siteSettings?.alertNotificationNoNotificationMessage} />);
	}

	if (!siteSettingsLoaded){
		return <LoadingCircle />;
	}

	return (

		<PageContainer>
			<MainContent>
				<div>
					<PageHeader headerText={siteSettings?.alertNotificationPageTitle} />

					<RenderNoNotificationsMessage />
					
					<SearchApp initialList={initialList} appName={`notification-${new Date().toString()}`}>
						<div >

							<div>
								<SearchList
									renderList={
										(notification: Notification) => {
											const mappedNotification = MapNotification(notification, siteSettings?.notificationMapping);
											return <NotificationItem key={notification.notification_id.toString()} notification={mappedNotification} dismissHandler={dismissHandler} removable={false} />;
										}
									}
									renderPagination={
										(totalCounts, name) => {
											return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings?.nextButton} prevButton={searchSettings?.previousButton} />;
										}
									}
								/>
							</div>
						</div>
					</SearchApp>
				</div>
			</MainContent>
			<SideBarContent>
				<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
			</SideBarContent>
		</PageContainer>


	);

}